

<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="page-user-list">
    <!-- Add User and Send Invite -->
    <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
      <feather-icon
          icon="Edit3Icon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="activePrompt = true" type="filled"
      >
      </feather-icon>
      <feather-icon
          icon="Trash2Icon"
          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
          @click="confirmDeleteRecord"
      />
    </div>

    <!-- Add User Prompt -->
    <vs-prompt
        :title="$t('updateCoach')"
        :accept-text="$t('Update')"
        :cancel-text="$t('Cancel')"
        @cancel="clearFields"
        @accept="assignCoach"
        @close="clearFields"
        :is-valid="validateEmail"
        :active.sync="activePrompt"
    >

      <form @submit.prevent style="height: 180px;">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full mt-8">

            <span>{{$t('Coachee')}}</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full mt-8">
            <component
                :is="scrollbarTag"
                class="scroll-area "
                :settings="settings"
                :key="$vs.rtl"
            >
              <v-select
                  v-model="trainee"
                  label="label"
                  :options="[{label:this.params.data.traineeName,value:this.params.data.id}]"
              ></v-select>
            </component>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full mt-12">
            <span>{{$t('Coach')}}</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full mt-12">
            <component
                :is="scrollbarTag"
                class="scroll-area "
                :settings="settings"
                :key="$vs.rtl"
            >
              <v-select
                  v-model="coach"
                  label="label"
                  :options="coach_list"
              ></v-select>
            </component>
          </div>
        </div>
      </form>

    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { models } from "feathers-vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import i18n from "@/i18n/i18n";
// import ccd from "@/assets/data/charactersistic-competency-definition.js";

export default {
  name: "SendInvite",
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  // props:trainee_list,
  data() {
    return {
      CCD: this.$t("addNewSkill.data"),
      trainee: null,
      trainee_competency: null,
      coach: null,
      trainee_competency_list: [],
      coach_list: [],
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      }
    };
  },
  watch: {},
  computed: {
    validateEmail() {
      return !this.errors.any() && this.user_email !== "";
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    fetchTraineeCompetency() {
      // Fetch All Trainee Competencies
      console.log()
      this.$store
          .dispatch("trainee-competencies/find", {query: {usersId: this.trainee.id}})
          .then(res => {
            if(res.total > 0) {
              this.trainee_competency_list = res.data;
              console.log("trainee competency list", this.trainee_competency_list);
              for(const tc in res.data) {
                const competency_id = (this.trainee_competency_list[tc]["competencyId"]).split("-")
                this.trainee_competency_list[tc]["label"] = this.CCD[competency_id[0]].competencies[competency_id[1]].comp
              }
            }
          })
          .catch(err => {
            console.log("could not find trainee competencies", err);
          });

      console.log(this.trainee, this.coach, this.trainee_competency)
    },
    printValues() {
      console.log(this.trainee, this.coach, this.trainee_competency)
    },
    clearFields() {
      this.$nextTick(() => {
        this.user_email = "";
      });
    },
    assignCoach() {
      // console.log('models', models)

      let trainee_coach={};
      console.log(this.params.data.traineeId,this.coach.id,this.params.data.id);
      if(this.params.data.traineeId===this.coach.id){
        this.$vs.notify({
          title: i18n.t('notification.admin.assignCoach.coachAssigned.warning.f1'),
          text:  i18n.t('notification.admin.assignCoach.coachAssigned.warning.f2'),
          color: "danger"
        });

      }
      else{
        if(window.$cookies.get('companyId')) {
          trainee_coach = {
            traineeId: this.params.data.trainee_id,
            coachId: this.coach.id,
            id:this.params.data.id,
            companyId:window.$cookies.get('companyId'),
            status: 'active'
          };
        }else{
          trainee_coach = {
            traineeId:this.params.data.trainee_id,
            coachId: this.coach.id,
            id:this.params.data.id,
            status: 'active'
          };
        }

        console.log("model", trainee_coach);

        this.$store
            .dispatch("traineeCoachAssignment/updateAssignTraineeCoach", trainee_coach)
            .then(res => {
              console.log("trainee assigned to coach", res);

              this.$vs.notify({
                title: i18n.t('notification.admin.assignCoach.updateAssigned.success.u1'),
                text:  i18n.t('notification.admin.assignCoach.updateAssigned.success.u2'),
                color: "primary"
              });
              window.location.reload()
            })
            .catch(err => {
              console.log("coach assignment failed", err);
              this.$vs.notify({
                title: i18n.t('notification.admin.assignCoach.updateAssigned.failed.u1'),
                text:  i18n.t('notification.admin.assignCoach.updateAssigned.failed.u2'),
                color: "danger"
              });
            });
      }

      // const trainee_coach = {
      //  // traineeId: this.trainee.id,
      //   coachId: this.coach.id,
      //   id:this.params.data.id,
      //   status: 'active'
      // };



      console.log("model", trainee_coach);




    },
    confirmDeleteRecord () {
      console.log(this.params.data);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:  i18n.t('notification.admin.user.confirm.success.c2'),
        text:  i18n.t('notification.admin.user.confirm.success.c3',{ traineeName: this.params.data.traineeName }),
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      // this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
          .dispatch("traineeCoachAssignment/removeAssignTraineeCoach", this.params.data.id)
          .then((res) => {
            console.log('going to remove company', res)
            this.$vs.notify({
              color: "primary",
              title: i18n.t('notification.admin.assignCoach.coachDeleted.success.d1'),
              text:  i18n.t('notification.admin.assignCoach.coachDeleted.success.d2')
            });
          })
          .catch(err => {
            console.error(err);
            this.$vs.notify({
              color: "danger",
              title: i18n.t('notification.admin.assignCoach.coachDeleted.failed.d1'),
              text:  i18n.t('notification.admin.assignCoach.coachDeleted.failed.d2')
            });
          });
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: "primary",
        title: i18n.t('notification.admin.assignCoach.showDeleteSuccess.success.d1'),
        text:  i18n.t('notification.admin.assignCoach.showDeleteSuccess.success.d2')
      });
    }
  },
  mounted () {

  },
  created () {
    // Fetch All Trainees
    //let trainee_list = [{label:'ramg2245@gmail.com',value:'1'}];


    // Fetch All Coaches
    let coachQuery={};
    if(window.$cookies.get('companyId')){
      coachQuery = {
        status: {
          $ne: 'deleted'
        },

        companyId:window.$cookies.get('companyId')
      }
    }else {
      coachQuery = {
        status: {
          $ne: 'deleted'
        },

      }
    }
    this.$store
        .dispatch("userManagement/fetchUsers", {query: coachQuery})
        .then(res => {
          this.coach_list = res.data;
          console.log("coach list", this.coach_list);
          for(const t in res.data) {
            this.coach_list[t]["label"] = `${this.coach_list[t]["firstName"]  } (${  this.coach_list[t]["email"]  })`
            this.coach_list[t]["value"] = this.coach_list[t]["id"]
          }
        })
        .catch(err => {
          console.log("could not find coaches", err);
        });
  }
};
</script>
<style lang="scss" scoped>
.scroll-area {
  position: absolute;
  margin: auto;
  width: 300px;
  height: 100%;
  &:not(.ps) {
    overflow-y: auto;
  }
}
@media (max-width: 767px) {
  .footer-next {
    position: fixed;
    bottom: 0;
    /*width: 100%;*/
    width: 100vw;
    left: calc(-50vw + 50%);
  }
}

.vx-card-next {
  /*border-radius: 0;
  border-radius: 0;*/
  box-shadow: none;
  -webkit-box-shadow: none;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
</style>

